import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./Footer.css";
import { FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  // Function to handle navigation
  const handleVisitCampus = (path) => {
    // Scroll to the top of the current page
    window.scrollTo(0, 0);
    // Navigate to the new page
    navigate(path);
  };

  return (
    <footer className="footer1">
      <h2 className="footer-title1">VISIT SHRI KHETESHWAR GURUKUL</h2>
      <div className="campus-container1">
        <div className="campus1">
          <h3>CAMPUS - MAYALWAS</h3>
          <p>Mayalawas</p>
          <p>Teh- Siwana</p>
          <p>Balotra - 344044</p>
          <p>9492821008</p>
          <button
            className="visit-btn1 orange"
            onClick={() => handleVisitCampus("/gurukul/mayalawas-gurukul")} // Navigate to Mayalawas page
          >
            Visit Our Campus
          </button>
        </div>

        <div className="campus1">
          <h3>CAMPUS - BIJROL KHEDA</h3>
          <p>Bijrol Kheda</p>
          <p>Teh- Sanchore</p>
          <p>Jalore - 343040</p>
          <p>9951615155</p>
          <button
            className="visit-btn1 yellow"
            onClick={() => handleVisitCampus("/gurukul/bijrol-kheda-gurukul")} // Navigate to Bijrol Kheda page
          >
            Visit Our Campus
          </button>
        </div>

        <div className="campus1">
          <h3>CAMPUS - SAYALA</h3>
          <p>Shri Kheteshwar Panchdham Mandir, Juna Gala</p>
          <p>Teh- Sayala</p>
          <p>Jalore - 343022</p>
          <p>9160221008</p>
          <button
            className="visit-btn1 red"
            onClick={() => handleVisitCampus("/gurukul/sayala-gurukul")} // Navigate to Sayala page
          >
            Visit Our Campus
          </button>
        </div>

        <div className="campus1">
          <h3>CAMPUS - SAWAI CHOTI</h3>
          <p>Sawai Choti (SanwalBas)</p>
          <p>Teh- Sardar Sahar</p>
          <p>Churu - 331403</p>
          <p>9603551008</p>
          <button
            className="visit-btn1 green"
            onClick={() => handleVisitCampus("/gurukul/sawai-choti-gurukul")} // Navigate to Sawai Choti page
          >
            Visit Our Campus
          </button>
        </div>

        <div className="campus1">
          <h3>CAMPUS - RAITHAL</h3>
          <p>Raithal</p>
          <p>Jalore</p>
          <p>Rajasthan</p>
          <p>9492821008</p>
          <button
            className="visit-btn1 orange"
            onClick={() => handleVisitCampus("/gurukul/raithal-gurukul")} // Navigate to Raithal page
          >
            Visit Our Campus
          </button>
        </div>
      </div>

      {/* Social Media Links */}
      <div className="social-icons1">
        <a
          href="https://www.instagram.com/shreekheteshwargurukul/?igsh=MXNqcnZ0M3dneHhjdg%3D%3D#"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className="icon" />
        </a>
        <a
          href="https://www.youtube.com/@shreekheteshwargurukul"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaYoutube className="icon" />
        </a>
      </div>

      <p className="copyright1">© 2025 Shri Kheteshwar Gurukul. All Rights Reserved.</p>

    </footer>
  );
};

export default Footer;